import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createChallengeAction = createAsyncThunk(
    'create-challenge',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/challenge`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createChallengeSlice = createSlice({
    name: 'create-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createChallengeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createChallengeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createChallengeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createChallengeReducer = createChallengeSlice.reducer    